export default {
  currentPatient: {
    notes: '',
    steps: 0,
    waterGlasses: 0,
  },
  patientsFilters: {},
  dialogPatientsFilters: {},
  exercisesFilters: {},
  patients: [],
  dialogPatients: [],
  loading: false,
  pagination: {},
  dialogPagination: {},
  journalDates: [],
  currentJournal: false,
  reloadJournalTimeout: false,
  patientProgramOptions: [
    { name: 'WLP (D2C)', value: 'wlp_d2c' },
    { name: 'Company WLP', value: 'practice_wlp' },
    { name: 'Company General', value: 'practice_general' },
  ],
  timedReleaseMessages: false,
  timedReleaseMessagesDefinitions: false,
  timedReleaseMessagesDefinitionResource: false,
  activity: false,
  exercises: false,
  exercise: false,
  reloadTimeoutExercises: false,
  exercisesCalendar: [],
  exercisesReport: false,
  exercisesReportTotals: false,
  exercisesDayReport: [],
  swaps: [],
  swap: null,
  swapsLoading: false,
  swapLoading: false,
  columnLayoutActive: false,
  screeners: [],
  screener: false,
  screenerProgress: null,
  participantsDashboard: null,
  currentAdvisorDashboardName: null,
  courses: [],
  currentCourse: null,
  currentCourseSteps: [],
  timedReleaseMessagesDates: [],
}
